module.exports = __webpack_public_path__ + "img/ThatsAllInTopicSmiley.bc7a9455.svg";